import { createSelector } from 'reselect';
import { USER_ADD_SUCCESS, UserActions } from './user.actions';
import { User } from './user';

export interface IUserState {
  details: User;
}

export const initialState: IUserState = {
  details: {} as User
};

export function userReducer(state = initialState, action: UserActions): IUserState {
  switch (action.type) {
    case USER_ADD_SUCCESS:
      return {
        details: action.payload
      };

    default: {
      return state;
    }
  }
}

export const getDetails = state => state.details;
export const getUserSelector = state => state.user;
export const getUserDetailsSelector = createSelector(getUserSelector, getDetails);
